import { FC } from 'react';

import { useWindow } from '@app/hooks/useWindow';
import { cn } from '@app/libs/utils';

export const ScreenType: FC<{ className?: string }> = ({ className }) => {
  const { screenType } = useWindow();

  if (process.env.NEXT_ENV === 'production') return <></>;

  return (
    <div
      className={cn(
        'fixed top-0 left-0 z-10000 bg-gray-900 h-8 w-8 text-white text-xs flex items-center justify-center',
        className
      )}
    >
      {screenType}
    </div>
  );
};

export default ScreenType;
